import { render, staticRenderFns } from "./AftercareViewDialog.vue?vue&type=template&id=4ed67f3a&scoped=true"
import script from "./AftercareViewDialog.vue?vue&type=script&lang=js"
export * from "./AftercareViewDialog.vue?vue&type=script&lang=js"
import style0 from "./AftercareViewDialog.vue?vue&type=style&index=0&id=4ed67f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed67f3a",
  null
  
)

export default component.exports